<template>
    <div id="app" class="h-full">
        <splide
            v-if="projekte.length > 0"
            :options="options"
            @splide:moved="onMoved"
            ref="slider"
        >
            <splide-slide>
                <Deckblatt :activeSlide="sliderIndex === 0" />
            </splide-slide>

            <template v-for="(projekt, index) in projekte">
                <splide-slide :key="`${index}-projekt-deckblatt`">
                    <ProjektDeckblatt
                        :projekt="projekt"
                        :bilder="projekt.multimedia.bilder.slice(0, 3)"
                        :activeSlide="sliderIndex === index+1"
                    />
                </splide-slide>
                <splide-slide
                    v-if="projekt.r_vertriebsstatus === 'FREI'"
                    :key="`${index}-projekt-details`"
                >
                    <ProjektDetails
                        :projekt="projekt"
                        :bilder="projekt.multimedia.bilder.slice(0, 3)"
                        :activeSlide="sliderIndex === index+1"
                    />
                </splide-slide>
                
                <template v-for="(bilder, indexBilder) in (projekt.chunkedBilder)">
                    <splide-slide
                        v-if="bilder.length > 5"
                        :key="`${index}-bilder-${indexBilder}`"
                    >
                        <Bilder
                            :projekt="projekt"
                            :bilder="bilder"
                            :activeSlide="sliderIndex === index+1"
                        />
                    </splide-slide>
                </template>

                <splide-slide :key="`${index}-lageplan`">
                    <Lageplan
                        :projekt="projekt"
                        :key="projekt.id"
                        :activeSlide="sliderIndex === index+1"
                    />
                </splide-slide>

                <splide-slide :key="`${index}-ansprechpartner`">
                    <ProjektAnsprechpartner
                        :projekt="projekt"
                        :key="projekt.id"
                        :activeSlide="sliderIndex === index+1"
                    />
                </splide-slide>
            </template>
        </splide>
    </div>
</template>

<script>
import axios from 'axios'
import chunk from 'lodash.chunk'
import ProjektDeckblatt from './components/Slides/ProjektDeckblatt.vue'
import ProjektDetails from './components/Slides/ProjektDetails.vue'
import ProjektAnsprechpartner from './components/Slides/ProjektAnsprechpartner.vue'
import Bilder from './components/Slides/Bilder.vue'
import Deckblatt from './components/Slides/Deckblatt.vue'
import Lageplan from './components/Slides/Lageplan.vue'

export default {
    data: () => ({
        apiUrl: process.env.VUE_APP_API_URL,
        apiKey: process.env.VUE_APP_API_KEY,

        projekte: [],

        // Slider
        options: {
            type: 'loop',
            perPage: 1,
            fixedWidth: '100vw',
            fixedHeight: '100vh',
            autoplay: process.env.VUE_APP_SLIDESHOW_AUTOPLAY === 'true',
            interval: parseInt(process.env.VUE_APP_SLIDESHOW_INTERVAL_SECONDS) * 1000,
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            accessibility: false,
            slideFocus: false,
            rewind: true,
        },

        sliderIndex: 0,

        // Timer
        timerReloadMinutes: parseInt(process.env.VUE_APP_TIMER_RELOAD_MINUTES),
        reloadTimerTimeout: null,
    }),


    destroyed() {
        clearInterval(this.reloadTimerTimeout)
    },

    async mounted() {
        this.projekte = [
            ...await this.getProjekte('projekte'),
            ...await this.getProjekte('referenzen'),
            ...await this.getProjekte('sonstige-projekte'),
        ]
        
        this.projekte = this.projekte.map((projekt) => ({...projekt, ...{ chunkedBilder: chunk(projekt.multimedia.bilder.slice(3), 6)}}))
        console.log(this.options)
        this.setReloadTimer()
    },

    methods: {
        setReloadTimer() {
            this.reloadTimerTimeout = setTimeout(() => location.reload(), this.timerReloadMinutes * 60 * 1000)
        },

        onMoved(newIndex, oldIndex) {
            this.sliderIndex = oldIndex
        },

        async getProjekte(art = '') {
            const response = await axios.get(`v3/immobilien/${art}?multimedia=true&thumbnails=tv&tv_praesentation=SHOP_FEUERBACHSTR_16`, {
                baseURL: this.apiUrl,
                headers: {
                    'x-api-key': this.apiKey
                }
            })

            return response.data.data
        }
    },

    components: {
        ProjektDeckblatt,
        ProjektDetails,
        ProjektAnsprechpartner,
        Bilder,
        Deckblatt,
        Lageplan,
    }
}
</script>